export default {
  /**
   * 已开放银行代码
   * CMB 招行
   * CCB 建行
   * SPD 浦发
   * PINGAN 平安
   * BOC 中行
   * BCM 交行
   * ICBC 工商
   * */
  ReadyBankCode: ['CMB', 'CCB', 'SPD', 'PINGAN', 'BOC', 'ICBC'],
  BankCodeToName: {
    CMB: '招商银行',
    CCB: '建设银行',
    SPD: '浦发银行',
    PINGAN: '平安银行',
    BOC: '中国银行',
    BCM: '交通银行',
    ICBC: '工商银行',
  },
  BizStatusOptions: [
    {
      name: '未评估',
      value: 'P',
    },
    {
      name: '评估中',
      value: 'SENDING',
    },
    {
      name: '评估通过',
      value: 'SUCCEED',
    },
    {
      name: '评估不通过',
      value: 'FAILED',
    }
  ],
};
